type IconSize = 'small' | 'large' | 'scale';

const getIconSize = ({ size }: { size?: IconSize }) => {
  switch (size) {
    case 'small':
      return '1rem';
    case 'large':
      return '1.5rem';
    case 'scale':
      return '100%';
    default:
      return '1rem';
  }
};

const getStrokeWidth = ({ strokeWidth }: { strokeWidth?: number }) => strokeWidth ?? 1.5;

export { getIconSize, getStrokeWidth };
export type { IconSize };
